/**
 * VeriWine REST API
 * Defintion of VeriWine REST API
 *
 * OpenAPI spec version: 0.1.1
 * Contact: info@short.ch
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpResponse, HttpHeaders} from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {SERVER_URL} from './server-url';
import {ApiUtilsService} from './api-utils.service'
import {
    OrgUnitDto,
    OrgUnitImageDto,
    OrgUnitImageInfoDto,
    OrgUnitNameDto,
    PageOrgUnitDto
} from '../domain';


@Injectable({
    providedIn: 'root'
})
export class OrgUnitControllerService {

    constructor(
        @Inject(SERVER_URL) private _serverUrl: string,
        private _httpClient: HttpClient,
        private _apiUtils: ApiUtilsService
    ) {
    }

    private _headers: HttpHeaders = undefined;

    addCustomHeader(headerName: string, headerValue: string | string[]): this {
        if (!this._headers) {
            this._headers = new HttpHeaders();
        }
        this._headers = this._headers.append(headerName, headerValue);
        return this;
    }


        addOrgUnitImage(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
                    , 
                    
                    requestBody: OrgUnitImageDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/${id}/image`;

            return this._httpClient.post<string>(url, requestBody, requestOptions);
    }


        approveOrgUnit(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/${id}/approve`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        createOrgUnit(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: OrgUnitDto
    ): Observable<number> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/orgunit`;

            return this._httpClient.post<number>(url, requestBody, requestOptions);
    }


        getAllOrgUnits(
                
                queryParams: {
                    ids?: Array<number>,
                    name?: string,
                    legalEntityType?: string,
                    userLegalEntityId?: number
                }
    ): Observable<Array<OrgUnitDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/all/restricted`;

            return this._httpClient.get<Array<OrgUnitDto>>(url, requestOptions);
    }


        getAllOrgUnits1(
    ): Observable<Array<OrgUnitDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/all`;

            return this._httpClient.get<Array<OrgUnitDto>>(url, requestOptions);
    }


        getAllOrgUnitsNames(
                
                queryParams: {
                    ids?: Array<number>,
                    name?: string,
                    legalEntityType?: string,
                    owner?: number
                }
    ): Observable<Array<OrgUnitNameDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/names`;

            return this._httpClient.get<Array<OrgUnitNameDto>>(url, requestOptions);
    }


        getAllOrgUnitsWhereProducer(
    ): Observable<Array<OrgUnitDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit`;

            return this._httpClient.get<Array<OrgUnitDto>>(url, requestOptions);
    }


        getOrgUnit(
                    unitId: number
    ): Observable<OrgUnitDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/${unitId}`;

            return this._httpClient.get<OrgUnitDto>(url, requestOptions);
    }


        getOrgUnitImage(
                    id: number,
                    imageId: number
    ): Observable<Array<string>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/${id}/image/${imageId}`;

            return this._httpClient.get<Array<string>>(url, requestOptions);
    }


        getOrgUnitImagesInfos(
                    id: number
    ): Observable<Array<OrgUnitImageInfoDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const requestOptions = {observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/${id}/image`;

            return this._httpClient.get<Array<OrgUnitImageInfoDto>>(url, requestOptions);
    }


        getOrganizationsByApprovalStatus(
                    status: string
                , 
                queryParams: {
                    ids?: Array<number>,
                    name?: string,
                    legalEntityType?: string,
                    userLegalEntityId?: number
                }
    ): Observable<Array<OrgUnitDto>> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/all/${status}`;

            return this._httpClient.get<Array<OrgUnitDto>>(url, requestOptions);
    }


        rejectOrgUnit(
                    id: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/${id}/reject`;

            return this._httpClient.post<boolean>(url, requestBody, requestOptions);
    }


        removeOrgUnit(
                    id: string
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/${id}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        removeOrgUnitImage(
                    id: number,
                    imageId: number
                , 
                queryParams: {
                    userLegalEntityId?: number
                }
    ): Observable<boolean> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/${id}/images/${imageId}`;

            return this._httpClient.delete<boolean>(url, requestOptions);
    }


        searchOrgUnitsPage(
                
                queryParams: {
                    ids?: Array<number>,
                    name?: string,
                    legalEntityType?: string,
                    userLegalEntityId?: number,
                    page?: number,
                    size?: number,
                    sort?: Array<string>
                }
    ): Observable<PageOrgUnitDto> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;
            const requestBody = undefined;

            const url: string = `${this._serverUrl}/api/orgunit/page`;

            return this._httpClient.get<PageOrgUnitDto>(url, requestOptions);
    }


        updateOrgUnit(
                
                queryParams: {
                    userLegalEntityId?: number
                }
                    
                    , 
                    requestBody: OrgUnitDto
    ): Observable<string> {
            const observe: 'body' = 'body';
            const responseType: 'json' = 'json';
            const headers: HttpHeaders = this._headers;
            this._headers = undefined;
            const params = this._apiUtils.sanitizeObject(queryParams);
            const requestOptions = {params, observe, responseType, headers};
            const formParams = undefined;

            const url: string = `${this._serverUrl}/api/orgunit`;

            return this._httpClient.put<string>(url, requestBody, requestOptions);
    }


}

